export default {
  warning: {
    id: 'document.journalEntry.toast.dataValidationWarning',
    defaultMessage: 'Data Validation Warning:',
  },
  error: {
    id: 'document.journalEntry.toast.invalidData',
    defaultMessage: 'Error:',
  },
  info: {
    id: 'document.journalEntry.toast.info',
    defaultMessage: 'Info:',
  },
};
